/**
 * Client-safe types + constants for the public dining section.
 *
 * Kept separate from `property-dining.ts` because that service imports the
 * server-only admin GraphQL client — a client component importing a VALUE from
 * it (not just a type) pulls the admin client into the browser bundle and the
 * build refuses.
 */

export interface DiningDish {
  id: string
  name_en: string
  name_ar: string | null
  course: string
  dietaryTags: string[]
}

export interface DiningMenu {
  id: string
  name_en: string
  name_ar: string | null
  mealType: string
  cuisine: { code: string; name_en: string; name_ar: string | null } | null
  dishes: DiningDish[]
}

export interface DiningMealPeriod {
  mealType: string
  label_en: string | null
  label_ar: string | null
  /** Postgres `time` — "06:30:00". */
  serviceTime: string | null
}

export interface PropertyDiningData {
  menus: DiningMenu[]
  mealPeriods: DiningMealPeriod[]
}

/** Serving order for meal groups on the public page. */
export const MEAL_TYPE_ORDER = ['breakfast', 'lunch', 'dinner', 'suhoor', 'iftar', 'snack', 'any'] as const
